module.exports = __webpack_public_path__ + "img/6.48b32a6f.png";